import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserManagementService } from 'app/modules/user-management/services/user-management.service';
import module from 'app/modules/user-management/user-management.module'

@Component({
  selector: 'app-add-roles-modal',
  templateUrl: './add-roles-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-roles-modal.component.scss']
})
export class AddRolesModalComponent {
  public newRoleName: string = ''
  public isSuccess: boolean = false
  public isLoading: boolean = false


  constructor(
    private userManagementService: UserManagementService,
    public dialogRef: MatDialogRef<AddRolesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public companyData: any,
    public dialog: MatDialog){
  }

  createRoles(){
    this.isLoading = true

    let roleBody = {
      name : this.newRoleName
    }

    this.userManagementService.createRoles(roleBody).subscribe((res)=>{
      if(res.isSuccess){
        this.isSuccess = res.isSuccess
        this.closeDialog()
      }

      this.isLoading = false
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }
}
